import { servicesApi } from "@common/services";
import { queryDownloadFile } from "../../common/pageable/query-download-file";

const FICHIER_URL_PREFIX = "fichiers";

const fichierApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    downloadFichier: build.mutation<void, { id: number }, any>({
      queryFn: ({ id }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${FICHIER_URL_PREFIX}/${id}/resource`,
      }),
    }),

  }),
});

export const {
  useDownloadFichierMutation,
} = fichierApi;